@import (reference) '../../../constants/spacing.module.less';

.copy-to-clipboard-button {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 24px;
  width: 24px;
  padding: @space-4;
}

.copy-to-clipboard-button-icon {
  height: 100%;
  width: 100%;
}
